import { Button, CheckboxGroup, GenericDialog, InputGroup } from '@/common'
import { useTranslation } from 'react-i18next'
import { AssetDefinition } from '@/shared/hooks/api/appConfig'
import { AssetInstanceSelect } from './AssetInstanceSelect'
import { useState } from 'react'

export function SingleAssetSelectDialog({
  isOpen,
  close,
  assetDefinitions,
  onAdd,
  question
}: {
  isOpen: boolean
  close: () => void
  assetDefinitions?: AssetDefinition[]
  onAdd: (payload: {
    assetDefinitionId: string | null
    customName: string | null
    isCustom: boolean
  }) => void
  question?: string
}) {
  const { t } = useTranslation()
  const [customName, setCustomName] = useState<string | null>(null)
  const [selectedAssetDefinitionId, setSelectedAssetDefinitionId] = useState<string | null>(null)
  const [isAddingCustomAsset, setIsAddingCustomAsset] = useState(assetDefinitions ? false : true)
  const isAddDisabled = !selectedAssetDefinitionId && !customName

  const resetState = () => {
    setSelectedAssetDefinitionId(null)
    setIsAddingCustomAsset(assetDefinitions ? false : true)
    setCustomName(null)
  }

  const onNotListedClick = (value: boolean) => {
    if (value) {
      setSelectedAssetDefinitionId(null)
      setIsAddingCustomAsset(true)
      setCustomName(null)
    } else {
      setIsAddingCustomAsset(false)
      setCustomName(null)
    }
  }

  const onChange = (assetDefinitionId: string | null) => {
    setSelectedAssetDefinitionId(assetDefinitionId)
  }

  const onAddClick = () => {
    if (!selectedAssetDefinitionId && !customName) {
      return
    }
    onAdd({
      assetDefinitionId: selectedAssetDefinitionId,
      customName,
      isCustom: isAddingCustomAsset
    })
    resetState()
  }

  return (
    <GenericDialog
      size="md"
      title={t('productionRoute:emissionPoints.assetInstanceSelect.title')}
      isOpen={isOpen}
      close={close}
    >
      <div className="space-y-8">
        {assetDefinitions && (
          <div className="space-y-2">
            <AssetInstanceSelect
              question={question}
              disabled={isAddingCustomAsset}
              assetDefinitions={assetDefinitions}
              selectedAssetDefinitionId={selectedAssetDefinitionId}
              onChange={onChange}
            />
          </div>
        )}

        <div className="gap-2 flex items-center">
          {assetDefinitions && (
            <div className="w-1/2">
              <CheckboxGroup
                id="not-listed"
                checked={isAddingCustomAsset}
                label={t('productionRoute:emissionPoints.assetInstanceSelect.notListed.label')}
                onChange={onNotListedClick}
              />
            </div>
          )}
          <div className="w-full">
            <InputGroup
              disabled={!isAddingCustomAsset}
              placeholder={t(
                'productionRoute:emissionPoints.assetInstanceSelect.customName.placeholder'
              )}
              value={customName ?? ''}
              onChange={evt => setCustomName(evt.target.value)}
            />
          </div>
        </div>
        <div className="gap-2 flex justify-end">
          <Button variant="neutral" onClick={close}>
            {t('common:actions.cancel')}
          </Button>
          <Button onClick={onAddClick} disabled={isAddDisabled}>
            {t('common:actions.add')}
          </Button>
        </div>
      </div>
    </GenericDialog>
  )
}
